<template>
	<div class="range-detector-section">
		<div class="range-detector-mute">
			<v-btn icon color="blue"  @click="toggleMute">
				<v-icon color="white" v-if="muted">volume_off</v-icon>
				<v-icon color="white" v-else>volume_up</v-icon>
			</v-btn>
		</div>
		<v-progress-gauge :size="150" :value="signalStrength">
			<h1>{{ signalStrength }}%</h1>
		</v-progress-gauge>
	</div>
</template>

<script>

  function easeOutQuad(x, t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
  };

  function linearMap(x, a, b, c, d) {
    return c + ( (d - c) / (b - a) ) * (x - a);
  }

  export default {
    name: 'RangeDetector',
	data() {
      return  {
        audioChannels: [],
		skipped: 0,
		interval: null,
		muted: false,
	  }
	},
	computed: {
      signalStrength() {
        if(!this.rssi) return 0;
        return Math.round(easeOutQuad(0, Math.min((100 + this.rssi) * 1.5, 100), 0, 100, 100));
      },
      rssi() {
        if (typeof ble === 'undefined') return null;
        return this.$store.state.ble.rssi;
      },
	},
	methods: {
      loop() {
        let loopsToSkip = Math.round(linearMap(this.signalStrength, 0, 100, 16, 1));
        if(++this.skipped >= loopsToSkip) {
          this.skipped = 0;
          this.beep();
        }
      },
	  beep() {
        let currentChannel = this.audioChannels.find(channel => channel.readyForPlay);
        currentChannel.readyForPlay = false;
        currentChannel.play();
	  },
      toggleMute(){
        this.muted = !this.muted;
        (this.muted)
          ? clearInterval(this.interval)
		  : this.interval = setInterval(this.loop, 100);
	  }
	},
    created() {
      for(let i=0;i<8;i++){
        let channel = new Media('audio/beep.mp3', () => channel.readyForPlay = true);
        channel.readyForPlay = true
        this.audioChannels.push(channel);
	  }

      this.interval = setInterval(this.loop, 100);
    },
	destroyed() {
      clearInterval(this.interval);
    }
  };
</script>

<style lang="stylus">
	.range-detector-section
		display: flex
		justify-content: center
		padding: 2rem
		text-align: center

	.range-detector-mute
		position: absolute
		display: flex
		top: 2rem
		right: 1rem
		z-index: 9999
</style>
